module.exports = __webpack_public_path__ + "assets/img/tobooklink_logo.73323610.svg";